import { render, staticRenderFns } from "./addChild.vue?vue&type=template&id=9e713c76&"
import script from "./addChild.vue?vue&type=script&lang=js&"
export * from "./addChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e713c76')) {
      api.createRecord('9e713c76', component.options)
    } else {
      api.reload('9e713c76', component.options)
    }
    module.hot.accept("./addChild.vue?vue&type=template&id=9e713c76&", function () {
      api.rerender('9e713c76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/list/addChild.vue"
export default component.exports